import BaseService from '@peoplenet/vi-components-ui/src/middleware/BaseService';
import { getUserInfo } from '../../security/util';

class ServiceAccountService extends BaseService {
  prefix = '/service-account';

  async create() {
    const userInfo = getUserInfo();
    const { userName, sessionId, database, server } = window.geotabSession;

    const serviceAccount = {
      customerId: userInfo.customerId,
      database,
      server,
      sessionId,
      userName,
    };

    return await super.post(serviceAccount);
  }

  async skip() {
    const userInfo = getUserInfo();

    const serviceAccount = { customerId: userInfo.customerId };

    return await super.post(serviceAccount, `${this.prefix}/skip`);
  }
}
export default new ServiceAccountService();
